module.exports = __webpack_public_path__ + "static/media/live23_03_2024.517a164c.jpg";